<template>
  <div v-show="visible" class="sd-attribute-panel no-select round-corner shadow" v-drag>
    <div class="sd-head-default between-flex moveable">
      <div class="head-title ">{{ title }}</div>
      <div @click="close"><svg-icon icon-class='close' class="sd-hover clickable"></svg-icon></div>
    </div>
    <div class="sd-body-default"  @mousedown.stop="()=>{}">
      <div class="between-flex" style="padding:10px 20px;height: 30px;line-height: 30px;">
        <div class="function-left sd-flex">
          <span >筛选条件：</span>
          <div class="sd-flex" style="margin-right:10px">
            <el-input  v-if="isAdvancedQuery_" v-model="querySql_" style="width:400px" clearable size="small" class="input-with-select">
              <el-tooltip slot="append" class="item" effect="dark" content="构造查询语句" placement="top">
                <i class="el-icon-setting sd-hover sql-btn-setting" @click="handleOpenSqlConstructor"></i>
              </el-tooltip>
            </el-input>
            <div v-else>
              <el-select v-model="queryField_" placeholder="请选择" size='small' style="width:100px">
                <el-option v-for="field in displayFields_" :key="field.name" :label="field.alias" :value="field.name"></el-option>
              </el-select>
              <el-input v-model="queryValue_" style="width:300px" clearable size="small" class="input-with-select">
              </el-input>
            </div>
            
          </div>
          <el-button type="primary" icon="el-icon-search" @click="handleStartQuery">查询</el-button>
          <el-tooltip class="item" effect="dark" content="切换查询方式" placement="top">
            <el-button icon="el-icon-sort" type="text" circle @click="handleSwitchSqlModel"></el-button>
          </el-tooltip>
          
        </div>
       <div class="function-right sd-flex">
        <el-tooltip class="item" effect="dark" content="缩放至所选" placement="top">
          <el-button icon="el-icon-zoom-in" circle @click="handleZoomToSelected"></el-button>
        </el-tooltip>
       
        <el-tooltip class="item" effect="dark" :content="isTranslate_?'中文字段':'英文字段'" placement="top">
          <el-button circle @click="isTranslate_=!isTranslate_">{{isTranslate_?'中':'英'}}</el-button>
        </el-tooltip>
        
       </div>
      </div>
    <div class="attribute-panel__body">
      <attribute-table 
        ref='attributeTable' 
        :loading="loading_" :data='featureList_' 
        :translate="isTranslate_" 
        @current-change="handleCurrentChange" 
        @row-dblclick="handleZoomToSelected">
      </attribute-table>
    </div>
    
    <el-pagination 
      v-if="total_>0" 
      layout="prev, pager, next"  
      :current-page.sync ="currentPage_"
      :page-size="pageSize_" 
      :total="total_"
      @current-change="handleCurrentPageChange"
      hide-on-single-page
      :pager-count='pagerCount'/> 
      <div v-else style="height: 32px;"></div>
    </div>
    <sql-construction-dialog ref="sqlConstructor" @confirm="handleSetQuerySql"></sql-construction-dialog>
  </div>
</template>

<script>
import AttributeTable from '@/components/AttributeTable';
import SqlConstructionDialog from '@/components/SqlConstructionDialog';
import GeoserverLayer from './MapServer/GeoserverLayer';
import { getTranslate } from "@/api/layer.js"
export default {
  name: 'SdAttributePanel',
  components: { AttributeTable,SqlConstructionDialog },
  props: {
    visible: {
      type: Boolean,
      default() {
        return true
      },
    },
    pagerCount:{
      type:Number,
      default:11
    },
    projection:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      title:'属性表',
      globFieldMapping:{},
      globFieldValueMapping:{},

      fieldMapping_:{},
      fieldValueMapping_:{},
      displayFields_:[],

      layerInfo_:null,

      featureList_:[],
      loading_:false,
      isTranslate_:true,
      currentPage_:1,
      pageSize_:10,
      total_:0,
      
      isAdvancedQuery_:false, //高级sql查询切换
      queryField_:'',
      queryValue_:'',
      querySql_:'',

      lastAttributeKey_:null,
      globalIndex_:0,

    };
  },
  created(){
    getTranslate().then(res=>{
      const jsonObj = this.tryGetJsonObject(res.data?.data[0].replaceStr)
      this.globFieldMapping = this.formatFieldMapping(jsonObj)
    })
    
    //获取全局字段值映射
    this.globFieldValueMapping = {}
  },
  mounted() {
    this.$el.addEventListener('contextmenu',(event)=>{
      event.preventDefault()
      this.$contextmenu({
        items:[
          {label:'关闭属性表',onClick:()=>{this.close() },icon: "el-icon-close", },
        
        ],
        event, 
        customClass: "map-right-menu", 
        zIndex: 100, 
        minWidth: 130 
      })
    })
  },

  methods: {
    handleSwitchSqlModel(){
      console.log(this.isAdvancedQuery_,this.querySql_==='');
      if (!this.isAdvancedQuery_ && this.querySql_==='') {
        this.querySql_ = this.getQuerySql()
      }
      this.isAdvancedQuery_=!this.isAdvancedQuery_

    },
    handleOpenSqlConstructor(){
      this.$refs.sqlConstructor && this.$refs.sqlConstructor.open(this.querySql_,this.displayFields_)
    },
    handleSetQuerySql(sql){
      this.querySql_ = sql
    },
    handleCurrentChange(row){
      this.$emit('select-change',row)
    },
    handleZoomToSelected(){
      this.$emit('zoom-to-selected')
    },
    handleStartQuery(){
      this.currentPage = 1
      this.getPageData()
    },
    handleCurrentPageChange(){
      this.getPageData()
    },
    init(lyr){
      this.layerInfo_ = {
        name:lyr.name,
        alias:lyr.alias || lyr.name,
        data:lyr,
        definition:lyr.definition,
        geoserverDriver:new GeoserverLayer({
          url:lyr.url,
          layer:lyr.name,
          projection:this.projection,
          count:this.pageSize_
        }),
      }
      this.title = `属性表(${this.layerInfo_.alias})`
      const fieldMapping=this.formatFieldMapping(lyr.data.fieldMapping)
      const fieldValueMapping=this.formatFieldMapping(lyr.data.fieldValueMapping)
      this.fieldMapping_ = Object.assign(fieldMapping,this.globFieldMapping)
      this.fieldValueMapping_ = Object.assign(fieldValueMapping,this.globFieldValueMapping)
     
      this.clearLayerQuery()
      this.getFirstPageData()
    },
    getFirstPageData(){
      this.currentPage_ = 1
      this.getPageData().then(()=>{
        this.queryField_ = this.displayFields_ && this.displayFields_.length ? this.displayFields_[0].name : ''
        this.queryValue_ = ''
        const ctr = this.$refs.attributeTable
        ctr && ctr.init({
          fields:this.displayFields_,
          fieldValueMapping:this.fieldValueMapping_
        })
      })
    },
    getPageData(){
      const sIndex  = this.getStartIndex(this.currentPage_);
      const driver = this.layerInfo_.geoserverDriver;
      return new Promise((resolve,reject)=>{
        if (!driver) {
          this.total_ = 0;
          this.featureList_ = [];
          this.displayFields_=[]
          resolve()
        }
        this.loading_ = true;
        let querySql = this.getQuerySql()
        const definition = this.layerInfo_.definition
        if (definition) {
          querySql && (querySql +=' AND ')
          querySql += definition
        }
        this.globalIndex_ = this.globalIndex_ + 1
        const key = Date.now().toString() + this.globalIndex_.toString()
        this.lastAttributeKey_ = key
        driver.attributeQuery(querySql,sIndex).then((json)=>{    
          console.log(key,this.lastAttributeKey_,key!==this.lastAttributeKey_);
          if (key!==this.lastAttributeKey_) return
          const feature = json.features[0]
          if (feature) {
            const fields = this.getFields(feature)
            //过滤掉不显示字段
            this.displayFields_ = this.getDisplayFields(fields,this.layerInfo_.data.hideFields)
          }
          this.total_ = json.totalFeatures;
          this.featureList_ = json.features || [];
          this.loading_=false
          resolve()
        })
      })
      
    },
    getStartIndex(pageIndex){
      return (pageIndex-1)*this.pageSize_;
    },
    getDisplayFields(fields,fiterFields){
      const hideFields = fiterFields || []
      const fieldObjs = []
      fields.forEach(field => {
        if (!hideFields.length || !hideFields.includes(field)) {
          fieldObjs.push({
            name:field,
            alias:this.getFieldMapping(field)
          })
        }
      })
      return fieldObjs
    },
    getQuerySql(){
      if (this.isAdvancedQuery_) {
        return this.querySql_
      }else if(this.queryField_ && this.queryValue_){
        return `${this.queryField_} like '${this.queryValue_}%'`
      }else{
        return ''
      }
    },
    getFields(feature){
      let fields = []
      if (feature) {
        fields = Object.keys(feature.properties)
      }
      return fields
    }, 
    getFieldMapping(name){
      return this.fieldMapping_? this.fieldMapping_[name.toUpperCase()] || name : name
    },
    formatFieldMapping(oldFieldMapping){
      //默认字段名称为大写
      const fieldMapping = {}
      if(oldFieldMapping){
        for(const [key,value] of Object.entries(oldFieldMapping)){
          fieldMapping[key.toUpperCase()] = value
        }
      }
      return fieldMapping
    },
    tryGetJsonObject(jsonStr){
      let obj = {}
      try{
        obj = JSON.parse(jsonStr)
      }catch(e){
        obj = {}
      }
      return obj
    },
    clearLayerQuery(){
      this.queryField_ =''
      this.querySql_=''
      this.queryValue_ =''
    },
    close(){
      this.$emit('select-change',null)
      this.$emit('update:visible', false)
    },
  },
};
</script>

<style scoped>
.sd-attribute-panel{
  position: absolute;
  top: calc(100% - 380px);
  left: 420px;
  z-index: 50;
  width:60vw;
  min-width: 750px;
}
.attribute-panel__body{
  height: 250px;
  width: 100%;
}
.sql-btn-setting{
  line-height: 25px;
  font-size:20px;
  /* margin-left: 10px; */
}
</style>